module.exports = new __parcel__URL__("kiwi.13ce1a05.svg").toString();